import { getTiresDisposalsApi } from 'api/tires-disposals';
import { PAGE_SIZE } from 'common/constants';
import { AppRoute } from 'common/enums/app/app-route';
import { HistoryContainer } from 'components/history-container';
import { HistoryItem } from 'components/history-item';
import { Loader } from 'components/loader';
import { Navbar } from 'components/navbar';
import { NoData } from 'components/no-data';
import { Pagination } from 'components/paginations';
import { Search } from 'components/search';
import { Subheader } from 'components/subheader';
import { UpdatedAt } from 'components/updated-at';
import { dateToHeaderFormat } from 'helpers/date';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getServiceAllUpdatesAction } from 'store/service-all-updates/actions';
import { useAppDispatch, useTypedSelector } from 'store/store';
import { getDisposalsHistoryAction } from 'store/tires-disposals-history/actions';

export const TiresDisposalsHistoryPage = () => {
  const dispatch = useAppDispatch();
  const { disposalsHistory, isLoading } = useTypedSelector(
    (state) => state.disposalsHistory
  );
  const { serviceUpdates } = useTypedSelector((state) => state.serviceUpdates);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const page = searchParams.get('page');
    dispatch(getDisposalsHistoryAction(`?page=${page || 1}`));
    dispatch(getServiceAllUpdatesAction());
  }, [dispatch, searchParams]);

  return (
    <>
      <Navbar>
        <Search
          fetcher={getTiresDisposalsApi}
          rootPath={AppRoute.UTILIZATION}
        />
      </Navbar>
      <Subheader title="Історія" backRoute={AppRoute.UTILIZATION}>
        {!!serviceUpdates.results.length &&
          !!disposalsHistory.results.length && (
            <UpdatedAt absoluteAlign>
              {dateToHeaderFormat(
                serviceUpdates.results[0].service_disposals_table
              )}
            </UpdatedAt>
          )}
      </Subheader>
      {isLoading ? (
        <Loader isBig position="static" />
      ) : disposalsHistory.results.length ? (
        <HistoryContainer withPagination={disposalsHistory.count > PAGE_SIZE}>
          {disposalsHistory.results.map((item, i) => (
            <HistoryItem
              key={i}
              title={item.history_message}
              date={item.confirmed_at}
            />
          ))}
        </HistoryContainer>
      ) : (
        <NoData height="calc(100vh - 162px)" />
      )}
      {disposalsHistory.count > PAGE_SIZE ? (
        <Pagination count={disposalsHistory.count} />
      ) : (
        ''
      )}
    </>
  );
};
